export const rideshareData = {
  config: {
    id: 'rideshare',
    name: 'RideShare',
    subtitle: 'Premium Bike Rental',
    supportEmail: 'support@rideshare.com',
    customMessage: 'Interested in a different rental period? Send us an email',
    currency_code: 'USD',
    currency_symbol: '$',
    timezone: 'America/New_York',
    country_code: 'US',
    default_language: 'en',
    supported_languages: ['en', 'de', 'fr', 'it', 'es', 'hu', 'fi'],
    debug: false,
  },
  popularDurations: ['9h'],
  locations: [
    {
      id: 'downtown',
      slug: 'downtown',
      name: 'Downtown Hub',
      address: '123 Main Street, City Center',
      hours: '6:00 AM - 10:00 PM',
      rating: 4.8,
      bikes: 25,
      image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=250&fit=crop',
    },
    {
      id: 'riverside',
      slug: 'riverside',
      name: 'Riverside Station',
      address: '456 River Road, Waterfront',
      hours: '7:00 AM - 9:00 PM',
      rating: 4.9,
      bikes: 18,
      image: 'https://images.unsplash.com/photo-1544191696-15693072ce6b?w=400&h=250&fit=crop',
    },
  ],
  bikes: [
    {
      id: 'mountain-pro',
      name: 'Mountain Pro X1',
      category: 'Mountain Bikes',
      price: 45,
      image: 'https://images.unsplash.com/photo-1544191696-15693072ce6b?w=400&h=300&fit=crop',
      sizes: [
        { size: 'M', height: '165-180cm' },
        { size: 'L', height: '175-190cm' },
        { size: 'XL', height: '185-200cm' },
      ],
      features: ['21-Speed Shimano', 'Front Suspension', 'Disc Brakes', 'All-Terrain Tires'],
      description: 'Perfect for off-road adventures with premium components and rugged design.',
      availableAddons: ['insurance', 'gps', 'premium_helmet'],
    },
    {
      id: 'city-comfort',
      name: 'City Comfort Cruiser',
      category: 'City Bikes',
      price: 35,
      image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop',
      sizes: [
        { size: 'S', height: '150-165cm' },
        { size: 'M', height: '160-180cm' },
        { size: 'L', height: '175-190cm' },
      ],
      features: ['Comfortable Seat', 'Built-in Basket', '7-Speed', 'LED Lights'],
      description: 'Ideal for city commuting with comfort and convenience features.',
      availableAddons: ['insurance', 'gps'],
    },
    {
      id: 'electric-boost',
      name: 'Electric Boost E-Bike',
      category: 'Electric Bikes',
      price: 75,
      image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=400&h=300&fit=crop',
      sizes: [
        { size: 'M', height: '160-180cm' },
        { size: 'L', height: '175-190cm' },
        { size: 'XL', height: '185-200cm' },
      ],
      features: ['50km Range', 'USB Charging', 'LCD Display', 'Pedal Assist'],
      description: 'Experience effortless riding with electric assistance and smart features.',
      popular: true,
      availableAddons: ['insurance', 'gps', 'phone_holder'],
    },
    {
      id: 'road-speed',
      name: 'Road Speed Racer',
      category: 'Road Bikes',
      price: 55,
      image: 'https://images.unsplash.com/photo-1502744688674-c619d1586c9e?w=400&h=300&fit=crop',
      sizes: [
        { size: 'S', height: '155-170cm' },
        { size: 'M', height: '165-180cm' },
        { size: 'L', height: '175-190cm' },
      ],
      features: ['Carbon Frame', '16-Speed', 'Drop Handlebars', 'Racing Tires'],
      description: 'Built for speed and performance on paved roads and long distances.',
      availableAddons: ['insurance', 'premium_helmet'],
    },
    {
      id: 'hybrid-versatile',
      name: 'Hybrid Versatile',
      category: 'City Bikes',
      price: 40,
      image: 'https://images.unsplash.com/photo-1571068316344-75bc76f77890?w=400&h=300&fit=crop',
      sizes: [
        { size: 'S', height: '150-165cm' },
        { size: 'M', height: '160-180cm' },
        { size: 'L', height: '175-190cm' },
        { size: 'XL', height: '185-200cm' },
      ],
      features: ['Hybrid Design', '21-Speed', 'Puncture Resistant', 'Quick Release'],
      description: 'The perfect blend of comfort and performance for any terrain.',
      availableAddons: ['insurance', 'gps'],
    },
    {
      id: 'family-tandem',
      name: 'Family Tandem',
      category: 'Specialty',
      price: 65,
      image: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=400&h=300&fit=crop',
      sizes: [{ size: 'One Size', height: '160-190cm' }],
      features: ['Two Seats', 'Shared Pedaling', 'Extra Stable', 'Fun Experience'],
      description: 'Share the adventure with a loved one on this stable tandem bike.',
      availableAddons: ['child_seat', 'insurance'],
    },
  ],
  addons: {
    insurance: {
      id: 'insurance',
      name: 'Rental Insurance',
      description: 'Covers damages and theft during your rental period.',
      price: 15.0,
      priceType: 'fixed',
    },
    gps: {
      id: 'gps',
      name: 'GPS Navigation',
      description: 'Explore with confidence using our handlebar-mounted GPS device.',
      price: 10.0,
      priceType: 'fixed',
    },
    phone_holder: {
      id: 'phone_holder',
      name: 'Phone Holder',
      description: 'Keep your phone secure and accessible while you ride.',
      price: 5.0,
      priceType: 'fixed',
    },
    premium_helmet: {
      id: 'premium_helmet',
      name: 'Premium Helmet',
      description: 'Upgrade to a lightweight helmet for extra comfort and safety.',
      price: 8.0,
      priceType: 'fixed',
    },
    child_seat: {
      id: 'child_seat',
      name: 'Child Seat',
      description: 'For children up to 40 lbs. Safety first!',
      price: 20.0,
      priceType: 'fixed',
    },
  }
};